/**
 * What the free plan includes, as the mock-ups (`Brand Onboarding v2`,
 * `Freemium - Plans et Paywalls`) size it: no API serves these limits yet, so
 * they live here, in one place. Its fees are not here: they come from the
 * shared `PLAN_FEE_GRID` the server charges from, and the paid plans are quoted
 * from the API.
 */
export const FREE_PLAN_OFFER = {
  monthlyCreatorSearches: 15,
  /** The Companion is a trial on the free plan (decision of 6 October 2026). */
  monthlyCompanionRecommendations: 3,
} as const;
